<template>
<v-card flat tile height="100%">

    <v-alert tile text
      border="left"
      class="caption px-3 py-1">
      Use the settings below to see how your notifications will look for different spaces,
      appointment types and locations.<br/>

      Click <strong >edit notification</strong> above to customise your notifications
    </v-alert>
    <!-- <v-checkbox v-model='settings.is_online' label='Online appointment' class='my-0 py-0' dense /> -->

    <space-picker chips v-model="settings.space" >
      <v-chip small slot="chips-after" :value="null" @click="settings.space=null;settings.product=null;" >Random</v-chip>
    </space-picker>

    <template v-if="settings.space" >
      <v-subheader class="overline">Choose an appointment type</v-subheader>
      <product-picker chips class="ml-4"
        v-model='settings.product'
        :space-id='settings.space'
        :multiple="false"
        :practitioner-id="meId"
        :return-object='true' >
        <v-chip small slot="chips-after" :value="null" >Random</v-chip>
      </product-picker>
    </template>

    <template v-if="settings.product && settings.product.locations && settings.product.is_online !== true && settings.product.comes_to_you !== true" >
      <v-subheader class="overline">Choose a location</v-subheader>
      <v-chip-group column class="ml-4"
        v-model="settings.addr" >
        <v-chip small active-class="primary"
          v-for="location in settings.product.locations" :key="location.id"
          :value='location' >{{location.name}}</v-chip>
        <v-chip small :value='null' >Random</v-chip>
      </v-chip-group>
    </template>

  <v-divider/>
  <v-card-actions>
    <v-spacer/>
    <v-btn
      @click='show=false;$emit("apply", parsedSettings)'
      :disabled="!settings.space"
      color='primary' >Update preview</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import SpacePicker from '@/components/pickers/SpacePicker.vue'
import ProductPicker from '@/components/pickers/ProductPicker.vue'
// import LocationPicker from '@/components/pickers/LocationPicker.vue'
import {mapGetters} from 'vuex'


export default {
  name: 'NotificationSettings',
  components: {
    SpacePicker, ProductPicker, // LocationPicker
  },
  props: {
    value: { type: Object, required: true },
    title: { type: String, default: 'Preview' },
    spaceId: { required: true }
  },
  data () {
    return {
      settings: {
        space: null,
        product: null,
        addr: null
      },
      customProduct: false,
      customAddr: false,
      show: false
    }
  },
  watch: {
    settings () {
      this.$emit('input', this.parsedSettings)
    }
  },
  computed: {
    ...mapGetters ('identity', ['meId']),
    parsedSettings () {
      let data = {}
      let space = this.settings.space
      let product = this.getObjectPath(this.settings, 'product.id', null)
      let addr = this.getObjectPath(this.settings, 'addr.id', null)

      if (space) { data['space'] = space }
      if (product) { data['product'] = product }
      if (addr) { data['address'] = addr }
      return data
    }
  }
}
</script>
